import { render, staticRenderFns } from "./goodsSku.vue?vue&type=template&id=3b102eb2&scoped=true"
import script from "./goodsSku.vue?vue&type=script&lang=js"
export * from "./goodsSku.vue?vue&type=script&lang=js"
import style0 from "./goodsSku.vue?vue&type=style&index=0&id=3b102eb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b102eb2",
  null
  
)

export default component.exports